angular.module('qkr').filter('templateBuilderTypeToReadable', (gettextCatalog) => function(formElement) {
        if (formElement.label.length > 0) {
            return formElement.label;
        } else {
            switch (formElement.type) {
                case 'CheckBoxList':
                    return gettextCatalog.getString('Pick Multiple');
                case 'OptionList':
                    return gettextCatalog.getString('Pick One');
                case 'Text':
                    return gettextCatalog.getString('Text Field');
                case 'Number':
                    return gettextCatalog.getString('Number Field');
                case 'YesNo':
                    return gettextCatalog.getString('Yes/No');
                case 'EmergencyContact':
                    return gettextCatalog.getString('Emergency Contact');
                default:
                    return formElement.type;
            }
        }
    });



// WEBPACK FOOTER //
// ./src/filters/template_builder_type_to_readable.js